import Axios from 'axios'
import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        user: null ,
        password: null,
    },
    mutations: {
        SET_LOGIN ( state , payload) {
            state.user =payload.user
            state.password = payload.password
        }
    },
    actions: {
        get_login: async ({commit, state }, payload)  =>{
            //let {data} = await Axios.post(api.baseUrl + 'login', {payload})
            // if (data.status == 200) {
            //     commit('SET_COMPANY', data)
            // }
            let data = await Axios.post(api.baseUrl + 'login', payload)
            console.log(data.data)
            if(!data.error){
                let user= data.result
                commit('SET_LOGIN', user)
            }
            
            //state.user = payload.user
           // console.log(state.user)
        },
        fetchUser: async ({ commit, state}, payload) => {
            let data =await Axios.post(api.baseUrl + 'users/login',  payload )
            data =data.data
            console.log(data.result)
            // if(!data.error){
            //     let user= data.result
            //     commit('SET_LOGIN', user)
            // }
        }
    }
}
